import { render, staticRenderFns } from "./ArrowIcon.vue?vue&type=template&id=d19718bc&scoped=true&"
import script from "./ArrowIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19718bc",
  null
  
)

export default component.exports